import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    const text = this.element.dataset.text || this.element.textContent;
    if (!text) {
      console.warn("No text associated with this clipboard");
      return;
    }

    const icon = document.createElement("i");
    icon.className = `fa-solid fa-circle-check`;
    let iconActive = false;

    this.element.addEventListener("click", (e) => {
      navigator.clipboard.writeText(text);
      e.preventDefault();

      if (!iconActive) {
        iconActive = true;
        let original = this.element.innerHTML;
        this.element.appendChild(icon);
        setTimeout(() => {
          this.element.innerHTML = original;
          iconActive = false;
        }, 1000);
      }
    });
  }
}
